import * as React from "react";
import { Row, Col, Alert } from "components/bootstrap";
const AuthBackendSubmitError = ({ error, backendId }) => {
  var _a, _b;
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 9, xsOffset: 3 }, /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "danger",
      style: { wordBreak: "break-word" },
      title: `Failed to ${backendId ? "edit" : "create"} authentication service`
    },
    (error == null ? void 0 : error.message) && /* @__PURE__ */ React.createElement(React.Fragment, null, error.message, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null)),
    (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text
  )));
};
export default AuthBackendSubmitError;
